import styled from 'styled-components';
import slide12 from 'assets/images/mobile/slide12.jpg';
export { SubtitleMobile } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
`;

export const Image = styled.img.attrs({ src: slide12 })`
  width: 100%;
`;
